export default async function getCalendarJP() {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL_BOOKDEMO_JP}/get-calendar`,
    {
      method: "GET",
      headers: {
        accept: "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY_BOOKDEMO_JP || "",
      },
    },
  );

  if (!response.ok) throw new Error("Network response was not ok");

  return response.json();
}
